class Password extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      form: 'form.password-form',
    };
  }

  connectedCallback() {
    this.form = this.querySelector(this._selectors.form);
    this._checkUrlQuery();
  }

  _checkUrlQuery() {
    const urlParams = new URLSearchParams(window.location.search);
    const pwdKey = urlParams.get('pwd');
    const pwdInput = this.querySelector('input[type="password"]');
    const pwd = window.pwd;

    if (pwdKey == 'true') {
      sessionStorage.setItem('pwdRedirect', true);
      pwdInput.value = pwd;
      this.form.submit();
    }
  }
}

customElements.define('s-password', Password);
